<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новый тариф',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новый тариф',
			items: [],
            tariff_uuid: '',
            trackBy: 'id',
            
            name: '',
            products: '',
            description: '',

            user: null,
            users_options: [],
            initUser: [],

            status: null,
            initStatus: [],
            status_options: [
                { id:'active',   name:'Активен' },
                { id:'wait',     name:'Ожидает активации' },
                { id:'disabled', name:'Отключен' },
            ],

		}
	},

    watch: {
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
        initUser: {
            immediate: true,
            handler(values) {
                this.user = this.users_options.filter(x => values.includes(x[this.trackBy]));
                this.user = this.user[0];
            }
        },
    },

	computed: {
        tariff_item(){
            return this.$store.getters['tariffs/GET_TARIFFS_ITEM'];
        },
        users_list_data(){
            return this.$store.getters['users/GET_USERS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {

        this.tariff_uuid = this.$route.params.tariff_uuid ? this.$route.params.tariff_uuid : '';

        let copy = this.$route.params.copy ? this.$route.params.copy : null;

        let users_data_send = {
            'limit': 1000
        }
        await this.$store.dispatch('users/FETCH_USERS_LIST', users_data_send);
        this.users_options = this.users_list_data;

        if(this.tariff_uuid !== ''){

            if(copy === null) {
                this.title = 'Редактирование тарифа';
                document.title = appConfig.title + ' - ' + 'Редактирование тарифа';
            }

            let data_send = {
                'uuid' : this.tariff_uuid,
            }

            await this.$store.dispatch('tariffs/FETCH_TARIFFS_ITEM', data_send);

            this.name = this.tariff_item.name;
            this.description = this.tariff_item.description;

            this.products = this.tariff_item.products ? this.tariff_item.products : null;

            this.user     = this.tariff_item.user_id ? this.tariff_item.user_id : null;
            this.initUser = [this.user];
            
            this.status = this.tariff_item.status ? this.tariff_item.status : null;
            this.initStatus = [this.tariff_item.status] ;


            if(copy === true){
                this.tariff_uuid = '';
            }
        }
	},

	methods: {

        async saveTariff(){

            let data_send = {
                'name'        : this.name,
                'description' : this.description,
                'products'    : this.products,
                'user_id'     : this.user && this.user.id ? this.user.id : null,
                'status'      : this.status && this.status.id ? this.status.id : null,
            };

            let result = '';

            if(this.tariff_uuid === ''){
                result = await this.$store.dispatch('tariffs/FETCH_TARIFFS_CREATE', data_send);
            } else {
                data_send.uuid = this.tariff_uuid;
                result = await this.$store.dispatch('tariffs/FETCH_TARIFFS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Tariffs'});
            }
        }
	}
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveTariff"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Название тарифа"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Владелец тарифа"
                                        label-for="user"
                                    >
                                        <multiselect
                                            id="user"
                                            v-model="user"
                                            :options="users_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Услуги"
                                        label-for="products"
                                    >
                                        <b-form-textarea
                                            id="products"
                                            v-model="products"
                                            rows="6"
                                        ></b-form-textarea>
                                    </b-form-group>

                                    <b-form-group
                                        label="Описание"
                                        label-for="description"
                                    >
                                        <b-form-input
                                            id="description"
                                            v-model="description"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
